let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4vOhV")).then(() => parcelRequire('hsEq1'));